(function (window, document) {
  "use strict";

  var DNB = (window.DNB = window.DNB || {});

  DNB.About = {
    init: function () {
      var root = document.querySelector("[data-about]"); 
      if (!root || root.getAttribute("data-about-init") === "1") return;
      root.setAttribute("data-about-init", "1");

      var play = root.querySelector("[data-about-play]");
      if (play) {
        play.addEventListener("click", function () {
          if (DNB.VideoPopup) DNB.VideoPopup.open();
        });
      }

      var stats = root.querySelectorAll("[data-stat-value]");
      if (!stats.length || !window.gsap) return;

      DNB.onScrollReady(function () {
        window.gsap.registerPlugin(window.ScrollTrigger);
        stats.forEach(function (el) {
          var target = parseFloat(el.getAttribute("data-stat-value")) || 0;
          var prefix = el.getAttribute("data-stat-prefix") || "";
          var suffix = el.getAttribute("data-stat-suffix") || "";
          var obj = { v: 0 };
          window.gsap.to(obj, {
            v: target,
            duration: 5,
            ease: "power1.out",
            scrollTrigger: { trigger: el, start: "top 88%", once: true },
            onUpdate: function () {
              var n = Math.round(obj.v);
              var text = n >= 10000 ? n.toLocaleString("tr-TR") : String(n);
              el.innerHTML = prefix + text + suffix;
            }
          });
        });
      });
    }
  };

  DNB.VideoPopup = {
    init: function () {
      var popup = document.querySelector("[data-video-popup]");
      if (!popup || popup.getAttribute("data-video-init") === "1") return;
      popup.setAttribute("data-video-init", "1");

      this.popup = popup;
      this.frame = popup.querySelector("[data-video-frame]");
      this.id = DNB.extractYoutubeId(popup.getAttribute("data-youtube-id") || "");

      var self = this;
      popup.querySelectorAll("[data-video-close]").forEach(function (btn) {
        btn.addEventListener("click", function () { self.close(); });
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") self.close();
      });
    },

    open: function () {
      if (!this.popup) return;
      this.popup.classList.add("is-open");
      if (DNB.ScrollService) DNB.ScrollService.lock();
      if (this.frame && this.id) {
        this.frame.innerHTML =
          '<iframe src="' + DNB.buildYoutubeEmbedUrl(this.id, { mute: true }) +
          '" allow="autoplay; encrypted-media; fullscreen; picture-in-picture" allowfullscreen title="YouTube video"></iframe>';
      }
    },

    close: function () {
      if (!this.popup || !this.popup.classList.contains("is-open")) return;
      this.popup.classList.remove("is-open");
      if (DNB.ScrollService) DNB.ScrollService.unlock();
      if (this.frame) this.frame.innerHTML = "";
    }
  };
})(window, document);
